import React, { useContext, useMemo } from 'react';
import { useTranslate } from '@awardit/react-use-translate';
import { SearchableDropdownField, Field } from '../Field/index.js';
import styles from 'shop-views/Address.scss';

var AddressField = _ref => {
  var type = _ref.type,
      autoComplete = _ref.autoComplete,
      label = _ref.label,
      name = _ref.name,
      StoreInfoContext = _ref.StoreInfoContext,
      settingsName = _ref.settingsName;

  var _useContext = useContext(StoreInfoContext),
      customerInputFieldsSettings = _useContext.info.customerInputFieldsSettings;

  var getFieldSetting = fieldName => {
    var _customerInputFieldsS, _customerInputFieldsS2;

    return (_customerInputFieldsS = (_customerInputFieldsS2 = customerInputFieldsSettings.find(item => item.field === fieldName)) == null ? void 0 : _customerInputFieldsS2.setting) != null ? _customerInputFieldsS : "normal";
  };

  var setting = getFieldSetting(settingsName);

  if (setting === "hidden") {
    return null;
  }

  return /*#__PURE__*/React.createElement(Field, {
    type: type,
    name: name,
    autoComplete: autoComplete,
    label: label,
    variant: "float",
    disabled: setting === "readonly"
  });
};

var ContactInfo = _ref2 => {
  var StoreInfoContext = _ref2.StoreInfoContext;
  var t = useTranslate();
  return /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, /*#__PURE__*/React.createElement(AddressField, {
    type: "email",
    autoComplete: "billing email",
    label: t("ADDRESS.EMAIL"),
    name: "email",
    StoreInfoContext: StoreInfoContext,
    settingsName: "email"
  }), /*#__PURE__*/React.createElement(AddressField, {
    type: "tel",
    autoComplete: "billing tel",
    label: t("ADDRESS.TELEPHONE"),
    name: "billing.telephone",
    StoreInfoContext: StoreInfoContext,
    settingsName: "telephone"
  }));
};
var Address = _ref3 => {
  var _customerInputFieldsS3, _customerInputFieldsS4;

  var type = _ref3.type,
      hasAddress = _ref3.hasAddress,
      StoreInfoContext = _ref3.StoreInfoContext;
  var t = useTranslate();

  var _useContext2 = useContext(StoreInfoContext),
      _useContext2$info = _useContext2.info,
      countries = _useContext2$info.countries,
      locale = _useContext2$info.locale,
      customerInputFieldsSettings = _useContext2$info.customerInputFieldsSettings;

  var countryFieldSetting = (_customerInputFieldsS3 = (_customerInputFieldsS4 = customerInputFieldsSettings.find(setting => setting.field === "country")) == null ? void 0 : _customerInputFieldsS4.setting) != null ? _customerInputFieldsS3 : "normal";
  var sortedCountries = useMemo(() => {
    return countries.slice().sort((a, b) => {
      return a.name.localeCompare(b.name, locale.split("_")[0], {
        sensitivity: "base"
      });
    });
  }, [countries, locale]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, /*#__PURE__*/React.createElement(AddressField, {
    type: "text",
    autoComplete: `${type} given-name`,
    label: t("ADDRESS.FIRSTNAME"),
    name: `${type}.firstname`,
    StoreInfoContext: StoreInfoContext,
    settingsName: "firstname"
  }), /*#__PURE__*/React.createElement(AddressField, {
    type: "text",
    autoComplete: `${type} family-name`,
    label: t("ADDRESS.LASTNAME"),
    name: `${type}.lastname`,
    StoreInfoContext: StoreInfoContext,
    settingsName: "lastname"
  })), hasAddress && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, /*#__PURE__*/React.createElement(AddressField, {
    type: "text",
    autoComplete: `${type} address-line1`,
    label: t("ADDRESS.STREET_1"),
    name: `${type}.street.0`,
    StoreInfoContext: StoreInfoContext,
    settingsName: "address"
  }), /*#__PURE__*/React.createElement(AddressField, {
    type: "text",
    autoComplete: `${type} address-line2`,
    label: t("ADDRESS.STREET_2"),
    name: `${type}.street.1`,
    StoreInfoContext: StoreInfoContext,
    settingsName: "address"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rowColumn
  }, /*#__PURE__*/React.createElement(AddressField, {
    type: "text",
    autoComplete: `${type} postal-code`,
    label: t("ADDRESS.POSTCODE"),
    name: `${type}.postcode`,
    StoreInfoContext: StoreInfoContext,
    settingsName: "postcode"
  }), /*#__PURE__*/React.createElement(AddressField, {
    type: "text",
    autoComplete: `${type} address-level2`,
    label: t("ADDRESS.CITY"),
    name: `${type}.city`,
    StoreInfoContext: StoreInfoContext,
    settingsName: "city"
  })), sortedCountries.length === 1 && /*#__PURE__*/React.createElement(AddressField, {
    type: "text",
    autoComplete: `${type} country`,
    label: t("ADDRESS.COUNTRY"),
    name: `${type}.countryName`,
    StoreInfoContext: StoreInfoContext,
    settingsName: "country"
  }), sortedCountries.length > 1 && countryFieldSetting !== "hidden" && /*#__PURE__*/React.createElement(SearchableDropdownField, {
    variant: "countryDropdown",
    label: t("ADDRESS.COUNTRY"),
    autoComplete: `${type} country`,
    className: styles.countries,
    name: `${type}.countryCode`,
    placeholder: "",
    items: sortedCountries,
    disabled: countryFieldSetting === "readonly"
  }))));
};

export { Address, ContactInfo };
//# sourceMappingURL=index.js.map
